import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { CoopPescaFormValidators } from './validators/coop-pesca.form-validators';
import { revisione53DatiFormSelectors } from '../../../store/selectors/dati-form.selectors';
import { manageSchedaDisabled, manageScObbl } from '../common/helper/scheda-settore.helper';
import { BaseRevisioneFormService } from '../../../abstracts/base-revisione-form.service';
import { DatiIdentificativiFormService } from '../../dati-identificativi/dati-identificativi-form.service';
import { formPaths } from '@shared/constants/form-paths.const';

@Injectable()
export class SchedaCoopPescaFormService extends BaseRevisioneFormService {
    isDisabled$: Observable<boolean>;

    constructor(protected datiIdentificativiService: DatiIdentificativiFormService) {
        super(undefined, undefined, datiIdentificativiService);
    }

    protected override initForm(): FormGroup {
        return this.fb.group(
            {
                my_SezioneI__Rilevazione: this.fb.group({
                    my_SchedaCoopPesca: this.fb.group({
                        my_ScPescaObbl: '',
                        my_GroupPesca: '',  // vestigiale: nodo XML my:GroupPesca (repeating section InfoPath) appiattito in NCR
                        my_ModoDiAssociazioneSchPesca: '',
                        my_CkPossiedeNatanti: '',
                        my_NumNatantiFinoA10: '',
                        my_NumNatantiOltre10: '',
                        my_AltreAttivitaPerSociPesca: '',
                        my_CkGestisceCentriRaccoltaPescato: '',
                        my_CkGestisceMercatiIttici: '',
                        my_CkGesctisceCentriAcquaColtura: '',  // typo intenzionale: campo XML InfoPath ha "Gesctisce" (non "Gestisce")
                        my_CkSchPescaGestisceAltro: '',
                        my_SchPescaGestisceAltroDesc: '',
                        my_ckAttProdGhiacc: '',
                        my_ckAttRifMateriali: '',
                        my_ckAttAttrezzi: '',
                        my_ckAttCarburanti: '',
                        my_ckAttTintReti: '',
                        my_ckAttSalagione: '',
                        my_ckAttTrasp: '',
                        my_ckAttAltro: '',
                        my_DescrNatanti: '',
                    }),
                }),
            },
            {
                updateOn: 'change',
                validators: CoopPescaFormValidators,
            }
        );
    }

    protected override afterFormInitialize(): void {
        this._manageDeactivation();
        manageScObbl(this.datiIdentificativiFormService, this._form, `${formPaths.schedaCoopPesca}.my_ScPescaObbl`);
    }

    private _manageDeactivation(): void {
        this.isDisabled$ = manageSchedaDisabled(this.store, revisione53DatiFormSelectors.getScPescaObbl);
    }
}
